"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.open = open;
var _social = require("../../types/social");
var _getIgnoreSocialDataForRegistration = require("./getIgnoreSocialDataForRegistration");
const getResolution = socialType => {
  switch (socialType) {
    case _social.ESocialType.AppleID:
      return [800, 600];
    default:
      return [400, 480];
  }
};
function open(parameters) {
  const {
    socialType
  } = parameters;
  return (dispatch, getState, context) => {
    const {
      config
    } = context;
    const [width, height] = getResolution(socialType);
    const top = (window.outerHeight - height) / 2;
    const left = (window.outerWidth - width) / 2;
    const ignoreSocialDataForRegistration = String((0, _getIgnoreSocialDataForRegistration.getIgnoreSocialDataForRegistration)(socialType, config));
    const socialLoginV2FlowEnabled = config.get('auth.socialLoginV2Flow.enabled') || false;
    const popupParams = [`width=${width}`, `height=${height}`, `scrollbars=0`, `top=${top}`, `left=${left}`].join(', ');
    window.open(`/auth/social-login/?type=${socialType}&ignoreSocialDataForRegistration=${ignoreSocialDataForRegistration}&v2Flow=${socialLoginV2FlowEnabled}`, 'Meow 🐾', popupParams);
  };
}